// src/components/ui/card.jsx
export function Card({ children, className }) {
  return <div className={`p-4 rounded-lg shadow bg-white ${className}`}>{children}</div>;
}

export function CardContent({ children, className }) {
  return <div className={`p-2 ${className}`}>{children}</div>;
}


export function CardReview({ children, className }) {
  return <div className={`p-4 rounded-lg shadow bg-slate-500 ${className}`}>{children}</div>;
}
